import React, { CSSProperties } from 'react'

// Styles
import './styles.scss'

export default ({
  styles,
  onClick,
}: {
  styles?: CSSProperties
  onClick: () => void
}) => {
  return (
    <button className={'button-friend-invite'} style={styles} onClick={onClick}>
      Пригласить друга
    </button>
  )
}
